import React, { FC } from 'react';
import {
  Box,
  makeStyles,
  createStyles,
  Typography,
} from '@material-ui/core';
import { createMuiTheme } from '@material-ui/core/styles';

const useStyles = makeStyles(() => createStyles({
  coverroot: {
    backgroundColor: '#0F4B8D',
    color: 'white',
    textAlign: 'left',
    height: '1122px',
    width: '793px',
    backgroundImage:
        "url('https://res.cloudinary.com/dxaubvelx/image/upload/c_lpad,h_1122,w_793/v1576728244/webassets/productcatalog/Page_1_Catalog_cu8ylo.png')",
  },
  spacer1: {
    height: '250px',
    width: '500px',
  },
  spacer2: {
    height: '150px',
    width: '500px',
  },
  spacer3: {
    height: '200px',
    width: '500px',
  },
  text: {
    width: '650px',
    marginLeft: '100px',
  },
  imageContainer: {
    height: '75px',
    textAlign: 'right',
    marginRight: '40px',
  },
  logoImage: {
    height: '75px',
  },
}));

interface CoverProps {
  coverTitle: string;
  coverWords: string[];
}

const Cover: FC<CoverProps> = (props) => {
  const theme = createMuiTheme();
  const classes = useStyles(theme);
  const logoImage = 'https://res.cloudinary.com/dxaubvelx/image/upload/v1576735537/webassets/productcatalog/Yellow-White_loqi9t.png';
  return (
    <Box className={classes.coverroot}>
      <Box className={classes.spacer1} />
      <Typography variant="h2" className={classes.text}>
        {props?.coverWords?.map((cw, idx) => (
          <div>
            {cw}
            {idx < props?.coverWords.length - 1 ? ' &' : ''}
          </div>
        ))}
      </Typography>
      <Box className={classes.spacer2} />
      <Typography variant="h5" className={classes.text}>
        {props?.coverTitle}
      </Typography>
      <Box className={classes.spacer3} />
      <Box className={classes.imageContainer}>
        <img
          className={classes.logoImage}
          src={logoImage}
          alt="inruta-logo"
        />
      </Box>
    </Box>
  );
};

export default Cover;
